var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    { staticClass: "video-feeds" },
    [
      _vm.loading
        ? _c("VLoading")
        : !_vm.loading && _vm.cards.length === 0
        ? _c("VEmpty")
        : [
            _c(
              "div",
              { staticClass: "video-feeds-content" },
              [
                _c(
                  "transition-group",
                  {
                    staticClass: "left-column",
                    attrs: { name: "cards", tag: "div" },
                  },
                  _vm._l(_vm.columnedCards.left, function (c) {
                    return _c("VideoCard", {
                      key: c.id,
                      attrs: {
                        orientation: "vertical",
                        "is-new": c.new,
                        "show-stats": false,
                        data: c,
                      },
                    })
                  }),
                  1
                ),
                _vm._v(" "),
                _c(
                  "transition-group",
                  {
                    staticClass: "right-column",
                    attrs: { name: "cards", tag: "div" },
                  },
                  _vm._l(_vm.columnedCards.right, function (c) {
                    return _c("VideoCard", {
                      key: c.id,
                      attrs: {
                        orientation: "vertical",
                        "is-new": c.new,
                        "show-stats": false,
                        data: c,
                      },
                    })
                  }),
                  1
                ),
              ],
              1
            ),
            _vm._v(" "),
            _vm.hasMorePage
              ? _c("ScrollTrigger", {
                  on: {
                    trigger: function ($event) {
                      return _vm.nextPage()
                    },
                  },
                })
              : _vm._e(),
          ],
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }